import React from 'react';

const Close = ({ className = '', title = '' }) => {
  return (
    <svg className={className} width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
      <title lang="en">{title}</title>
      <path d="M1.06897 1.06897L32.931 32.931" stroke="#FCEE21" strokeWidth="3"/>
      <path d="M1.06897 32.931L31.7931 2.20691" stroke="#FCEE21" strokeWidth="3"/>
    </svg>
  )
};

export default Close;
